import styles from "./AppliedFilter.module.scss";
import CloseIcon from "@mui/icons-material/Close";
import { LOCATION_FIELDS } from "./FilterConfig";
import type { ClearFilterFn } from "./FilterInterface";

interface Props {
    location: any;
    clearFilter: ClearFilterFn;
}

const closeIcon = <CloseIcon fontSize="small" />;

const LocationFilterChip = ({
    location,
    clearFilter,
}: Props) => {
    if (!location?.country) return null;

    return (
        <div className="flex items-center gap-4 ml-4">
            <div className={styles.filtersModeHead}>
                <span>By Location</span>

                <button
                    type="button"
                    className={styles.customClose}
                    onClick={() => clearFilter("location")}
                >
                    {closeIcon}
                </button>
            </div>

            {LOCATION_FIELDS.map((field) => {
                const value = location[field.key];

                if (!value?.[field.idKey]) return null;

                return (
                    <div
                        key={field.key}
                        className={styles.filtersMode}
                    >
                        <div className="inline-block">
                            {value[field.nameKey]}
                        </div>

                        <button
                            type="button"
                            className={styles.customClose}
                            onClick={() =>
                                clearFilter("location", field.key)
                            }
                        >
                            {closeIcon}
                        </button>
                    </div>
                );
            })}
        </div>
    );
};

export default LocationFilterChip;